import { createSelector } from 'reselect';

export const authSelector = (state) => state.auth;

export const userSelector = createSelector([authSelector], (authObj) => authObj.user);
